module.exports = __webpack_public_path__ + "static/media/Golden Boy.64357000.png";